<div class="page">
  <div class="panel">
    <h2 class="panel-title">Overall Inflation / Deflation Summary</h2>

    <div class="filters">
      <div class="field">
        <label>From Date</label>
        <input type="date" class="form-control" [(ngModel)]="begDate">
      </div>

      <div class="field">
        <label>To Date</label>
        <input type="date" class="form-control" [(ngModel)]="endDate">
      </div>

      <button class="btn" (click)="getData()">Search</button>
    </div>

    <div class="stats">
      <div class="stat">
        <div class="label">Changed Items</div>
        <div class="value neutral">{{ changedItems }}</div>
      </div>

      <div class="stat">
        <div class="label">Inflation Items</div>
        <div class="value inflation-text">▲ {{ inflationCount }}</div>
      </div>

      <div class="stat">
        <div class="label">Deflation Items</div>
        <div class="value deflation-text">▼ {{ deflationCount }}</div>
      </div>

      <div class="stat">
        <div class="label">Average Inflation</div>
        <div class="value inflation-text">▲ {{ avgInflation | number:'1.2-2' }}%</div>
      </div>

      <div class="stat">
        <div class="label">Average Deflation</div>
        <div class="value deflation-text">▼ {{ avgDeflation | number:'1.2-2' }}%</div>
      </div>
    </div>

    <div class="overall-chart-card">
      <div class="card-head">
        Overall Chart
        <div class="card-sub">Overall inflation and deflation view for the selected date range</div>
      </div>

      <div class="chart-box overall-chart-box">
        <canvas id="overallChart"></canvas>
      </div>
    </div>

    <div class="content-grid">
      <div class="detail-card">
        <div class="card-head">
          Detail Table
          <div class="card-sub">Changed items for the selected date range</div>
        </div>

        <div class="table-scroll fixed-height-scroll">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Code</th>
                <th>Name</th>
                <th>First Price</th>
                <th>Last Price</th>
                <th>Diff</th>
                <th>Change %</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="detailData.length === 0">
                <td colspan="8" class="empty">No changed items found</td>
              </tr>

              <tr *ngFor="let item of detailData; let i = index"
                  (click)="selectItem(item)"
                  [class.row-active]="selectedItem?.itemId === item.itemId"
                  class="clickable-row">
                <td>{{ i + 1 }}</td>
                <td>{{ item.itemCode }}</td>
                <td>{{ item.itemName }}</td>
                <td>{{ item.fromPrice | number:'1.2-2' }}</td>
                <td>{{ item.toPrice | number:'1.2-2' }}</td>
                <td [ngClass]="getChangeClass(item)">
                  {{ item.difference > 0 ? '+' : '' }}{{ item.difference | number:'1.2-2' }}
                </td>
                <td [ngClass]="getChangeClass(item)">
                  <ng-container *ngIf="item.changePercent != null; else noPercent">
                    {{ getArrow(item) }}
                    {{ item.changePercent < 0 ? (item.changePercent * -1 | number:'1.2-2') : (item.changePercent | number:'1.2-2') }}%
                  </ng-container>
                  <ng-template #noPercent>N/A</ng-template>
                </td>
                <td>
                  <span class="badge" [ngClass]="getBadgeClass(item)">
                    {{ item.status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="chart-card">
        <div class="card-head card-head-flex">
          <div>
            {{ selectedItem ? 'Item Price Chart' : 'Changed Items Chart' }}
            <div class="card-sub">
              <ng-container *ngIf="selectedItem; else allItemsSub">
                {{ selectedItem.itemCode }} - {{ selectedItem.itemName }}
              </ng-container>
              <ng-template #allItemsSub>
                Price trends of changed items in the selected date range
              </ng-template>
            </div>
          </div>

          <button *ngIf="selectedItem"
                  class="btn btn-secondary"
                  type="button"
                  (click)="showAllOverview()">
            All
          </button>
        </div>

        <div class="chart-box side-chart-box">
          <canvas id="itemChart"></canvas>
        </div>
      </div>
    </div>

    <div class="history-card">
      <div class="card-head card-head-flex">
        <div>
          {{ selectedItem ? 'Price History' : 'Overall Changed Items Table' }}
          <div class="card-sub">
            <ng-container *ngIf="selectedItem; else overallTableSub">
              Price history for the selected item
            </ng-container>
            <ng-template #overallTableSub>
              Full changed items list with price history for the selected date range
            </ng-template>
          </div>
        </div>

        <button class="btn btn-success" type="button" (click)="exportCurrentTableToExcel()">
          Export Excel
        </button>
      </div>

      <div class="table-scroll history-table-scroll">
        <table *ngIf="selectedItem; else overallChangedTable">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Price</th>
              <th>Previous Price</th>
              <th>Diff</th>
              <th>Change %</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="selectedItemHistory.length === 0">
              <td colspan="7" class="empty">No item history found</td>
            </tr>

            <tr *ngFor="let h of selectedItemHistory; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ h.orderDate }}</td>
              <td>{{ h.price | number:'1.2-2' }}</td>
              <td>{{ h.previousPrice == null ? '-' : (h.previousPrice | number:'1.2-2') }}</td>
              <td [ngClass]="h.rowStatus === 'Inflation' ? 'change-up' : h.rowStatus === 'Deflation' ? 'change-down' : ''">
                {{ h.previousPrice == null ? '-' : ((h.diff > 0 ? '+' : '') + (h.diff | number:'1.2-2')) }}
              </td>
              <td [ngClass]="h.rowStatus === 'Inflation' ? 'change-up' : h.rowStatus === 'Deflation' ? 'change-down' : ''">
                <ng-container *ngIf="h.previousPrice != null && h.changePercent != null; else noHistoryPercent">
                  {{ h.rowStatus === 'Inflation' ? '▲' : h.rowStatus === 'Deflation' ? '▼' : '' }}
                  {{ (h.changePercent < 0 ? h.changePercent * -1 : h.changePercent) | number:'1.2-2' }}%
                </ng-container>
                <ng-template #noHistoryPercent>-</ng-template>
              </td>
              <td>
                <span *ngIf="h.rowStatus !== 'No Change'; else noChangeBadge"
                      class="badge"
                      [ngClass]="h.rowStatus === 'Inflation' ? 'inflation' : 'deflation'">
                  {{ h.rowStatus }}
                </span>

                <ng-template #noChangeBadge>
                  <span class="badge neutral-badge">No Change</span>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #overallChangedTable>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Code</th>
                <th>Name</th>
                <th>First Price</th>
                <th>Last Price</th>
                <th>Diff</th>
                <th>Change %</th>
                <th>Status</th>
                <th>History</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="detailData.length === 0">
                <td colspan="9" class="empty">No changed items found</td>
              </tr>

              <tr *ngFor="let item of detailData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.itemCode }}</td>
                <td>{{ item.itemName }}</td>
                <td>{{ item.fromPrice | number:'1.2-2' }}</td>
                <td>{{ item.toPrice | number:'1.2-2' }}</td>
                <td [ngClass]="getChangeClass(item)">
                  {{ item.difference > 0 ? '+' : '' }}{{ item.difference | number:'1.2-2' }}
                </td>
                <td [ngClass]="getChangeClass(item)">
                  <ng-container *ngIf="item.changePercent != null; else noOverallPercent">
                    {{ getArrow(item) }}
                    {{ item.changePercent < 0 ? (item.changePercent * -1 | number:'1.2-2') : (item.changePercent | number:'1.2-2') }}%
                  </ng-container>
                  <ng-template #noOverallPercent>N/A</ng-template>
                </td>
                <td>
                  <span class="badge" [ngClass]="getBadgeClass(item)">
                    {{ item.status }}
                  </span>
                </td>
                <td class="history-cell">
                  <div *ngFor="let h of item.history">
                    {{ h.orderDate }} - {{ h.price | number:'1.2-2' }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </div>
  </div>
</div>
